<div class="ponude-container">
  <!-- Filters Section -->
  <div class="filters-section">
    <div class="filter-row">
      <!-- Country Dropdown -->
      <div class="filter-group">
        <label class="filter-label">Država</label>
        <dx-select-box [dataSource]="countries" displayExpr="name" valueExpr="code" placeholder="Odaberite državu..."
          [(value)]="selectedCountry" [searchEnabled]="true" class="filter-control">
        </dx-select-box>
      </div>

      <!-- Date Range Picker -->
      <div class="filter-group">
        <label class="filter-label">Raspon datuma</label>
        <dx-date-range-box displayFormat="dd.MM.yyyy" [startDate]="startDate" [endDate]="endDate" (startDateChange)="onStartDateChange($event)"
          (endDateChange)="onEndDateChange($event)" placeholder="Odaberite raspon datuma..." class="filter-control">
        </dx-date-range-box>
      </div>

      <!-- Execute Button -->
      <div class="filter-group">
        <label class="filter-label">&nbsp;</label>
        <dx-button text="Učitaj podatke" icon="search" type="default" stylingMode="contained" (onClick)="loadData()"
          [disabled]="!isFormValid()" class="execute-btn">
        </dx-button>
      </div>


      <div class="filter-group">
        <label class="filter-label">&nbsp;</label>
        <dx-button [visible]="isUserModerator" text="Kreiraj ponudu" icon="plus" type="default" stylingMode="contained"
          (onClick)="showCreatePonuda()" class="execute-btn">
        </dx-button>
      </div>
    </div>
  </div>

  <!-- Data Grid Section -->
  <div class="grid-section">
    <dx-data-grid #ponudeGrid id="ponudeGrid" keyExpr="id" [dataSource]="gridData" [showBorders]="true"
      [allowColumnResizing]="true" [showColumnLines]="true" [showRowLines]="true" [hoverStateEnabled]="true"
      [filterRow]="{ visible: true }" [searchPanel]="{ visible: true }" [paging]="{ pageSize: 50 }" [pager]="{
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true
      }" [selection]="{ mode: 'single' }" [rowAlternationEnabled]="true" (onRowPrepared)="onRowPrepared($event)">

      <!-- Columns Definition -->

      <dxi-column type="buttons" width="120" caption="Opcije" [visible]="isUserModerator">
        <dxi-button name="copy" icon="copy" hint="Kopiraj" [visible]="true" [onClick]="onCopyClick"></dxi-button>
        <dxi-button name="edit" icon="edit" hint="Izmijeni" [visible]="true" [onClick]="onEditClick"></dxi-button>
        <dxi-button name="delete" icon="trash" hint="Izbriši" [visible]="true" [onClick]="onDeleteClick"></dxi-button>
      </dxi-column>

      <dxi-column dataField="artikl1.artikl1" caption="Artikl"></dxi-column>
      <dxi-column dataField="opis" caption="Opis"></dxi-column>
      <dxi-column dataField="kolicina" caption="Količina"></dxi-column>
      <dxi-column dataField="mjesto_utovara" caption="Mjesto utovara"></dxi-column>
      <dxi-column caption="Cijena" [calculateCellValue]="calculateCurrencyCellValue"></dxi-column>
      <dxi-column dataField="dodatni_opis" caption="Dodatni opis"></dxi-column>
      <dxi-column dataField="firma1.naziv" caption="Firma"></dxi-column>
      <dxi-column dataField="datum" caption="Datum" dataType="date" format="dd.MM.yyyy"></dxi-column>
      <dxi-column dataField="firma1.telefon1" caption="Telefon"></dxi-column>
      <!-- <dxi-column dataField="title" caption="Title" [minWidth]="150"></dxi-column>
      <dxi-column dataField="country" caption="Country" [width]="100"></dxi-column>
      <dxi-column dataField="client" caption="Client" [minWidth]="120"></dxi-column>
      <dxi-column dataField="value" caption="Value" dataType="number" format="#,##0.00" [width]="120">
      </dxi-column>
      <dxi-column dataField="status" caption="Status" [width]="100">
        <dxo-lookup
          [dataSource]="statuses"
          displayExpr="name"
          valueExpr="value">
        </dxo-lookup>
      </dxi-column>
      <dxi-column dataField="startDate" caption="Start Date" dataType="date" format="dd/MM/yyyy" [width]="110"></dxi-column>
      <dxi-column dataField="endDate" caption="End Date" dataType="date" format="dd/MM/yyyy" [width]="110"></dxi-column>
      <dxi-column dataField="createdBy" caption="Created By" [width]="120"></dxi-column>
      <dxi-column dataField="lastUpdated" caption="Last Updated" dataType="datetime" format="dd/MM/yyyy HH:mm" [width]="140"></dxi-column> -->

      <!-- Master Detail -->
      <dxo-master-detail [enabled]="true" template="detailTemplate">
      </dxo-master-detail>

      <div *dxTemplate="let data of 'detailTemplate'" class="master-detail">
        <div class="detail-section">
          <h4>Detalji ponude: {{ data.data.artikl1.artikl1 }}</h4>
          <p><strong>Firma:</strong> {{ data.data.firma1.naziv || 'N/A' }}</p>
          <p><strong>Kontakt osoba:</strong> {{ data.data.firma1.kontakt1 || 'N/A' }}</p>
          <p><strong>Telefon:</strong> {{ data.data.firma1.telefon1 || 'N/A' }}</p>
          <p><strong>Grad:</strong> {{ data.data.firma1.grad1.grad1 || 'N/A' }}</p>
        </div>
      </div>
    </dx-data-grid>
  </div>

  <app-create-ponuda [visible]="createPonudaPopupVisible" (visibleChange)="createPonudaPopupVisible = $event"
    (ponudaCreated)="onPonudaCreated($event)"></app-create-ponuda>

  <app-edit-ponuda [visible]="editPonudaPopupVisible" (visibleChange)="editPonudaPopupVisible = $event"
    (ponudaEdited)="onPonudaEdited($event)" [ponuda]="selectedPonuda"></app-edit-ponuda>

  <!-- Loading Overlay -->
  <dx-load-panel [position]="loadPanelPosition" [visible]="loading" [showIndicator]="true" [showPane]="true"
    [shading]="true" shadingColor="rgba(0, 0, 0, 0.4)">
  </dx-load-panel>
</div>